class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Desktop-only hover-to-open. Guarded to real pointer devices so touch/
    // keyboard keep the native click-to-toggle behaviour (a11y preserved).
    this.desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover)');
    this.closeTimer = null;

    this.addEventListener('mouseenter', this.onHoverOpen.bind(this));
    this.addEventListener('mouseleave', this.onHoverClose.bind(this));

    // Neutralise mouse clicks on the parent so hover stays authoritative and a
    // click doesn't immediately re-close what the pointer just opened. Keyboard
    // activation dispatches a click with detail === 0, which we let through.
    this.mainDetailsToggle.querySelector('summary').addEventListener('click', (event) => {
      if (this.desktopHover.matches && event.detail !== 0) event.preventDefault();
    });
  }

  onHoverOpen() {
    if (!this.desktopHover.matches) return;
    clearTimeout(this.closeTimer);
    if (this.mainDetailsToggle.hasAttribute('open')) return;
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onHoverClose() {
    if (!this.desktopHover.matches) return;
    // Small delay so a diagonal cursor path from label to panel doesn't flicker.
    this.closeTimer = setTimeout(() => this.close(), 150);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
